function WeeklyReport() {
  return <div>Banners</div>;
}

export default WeeklyReport;
